<template>
<div :class="{
  'modal': true,
  'is-active': active
}">
  <div class="modal-background" @click="$emit('cancel')" ></div>

  <div class="modal-content">
    <div class="box content">

      <page-title :text="title" />

      <combobox-task-type
        :task-type-list="getApplicableTaskTypes()"
        v-model="selectedTaskTypeId"
      />

      <div class="flexrow">
        <a
          :class="{
            button: true,
            'flexrow-item': true,
            'is-primary': true,
          }"
          @click="confirmClicked"
        >
          {{ $t("main.confirmation") }}
        </a>
        <button
          @click="$emit('cancel')"
          class="button is-link"
        >
          {{ $t("main.cancel") }}
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { modalMixin } from '@/components/modals/base_modal'
import ComboboxTaskType from '@/components/widgets/ComboboxTaskType'
import PageTitle from '@/components/widgets/PageTitle'

export default {
  name: 'create-global-task-modal',
  mixins: [modalMixin],

  components: {
    ComboboxTaskType,
    PageTitle
  },

  props: {
    active: {
      type: Boolean,
      default: false
    },
    management: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      selectedTaskTypeId: ''
    }
  },

  computed: {
    ...mapGetters([
      'productionManagementTaskTypes',
      'taskTypes'
    ]),

    title () {
      if (this.management) {
        return this.$t('management.create_task')
      } else {
        return this.$t('global.create_task')
      }
    }
  },

  methods: {
    ...mapActions([
      'loadTaskTypes'
    ]),

    getApplicableTaskTypes () {
      if (this.management) {
        return this.productionManagementTaskTypes
      } else {
        return this.taskTypes.filter(tskTyp => tskTyp.for_entity === 'Global')
      }
    },

    confirmClicked () {
      this.$emit('confirm', {
        taskTypeId: this.selectedTaskTypeId
      })
    }
  },

  mounted () {
    this.loadTaskTypes().then(() => {
      const taskTypes = this.getApplicableTaskTypes()
      if (taskTypes.length > 0) {
        this.selectedTaskTypeId = taskTypes[0].id
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.info-message {
  margin-top: 1em;
}

.widden {
  margin-bottom: 12em;
}

.flexrow-item {
  margin-right: 0;
}
</style>
